import {Button} from "@material-ui/core";
import { asBlob } from 'html-docx-js-typescript'
import { saveAs } from 'file-saver';
import { injectIntl, FormattedMessage } from "react-intl";

const BillExportToDocx = ({
  title,
  elementId,
  intl
}) => {
  const downloadDocx = () => {
    const content = document.getElementById(elementId);
    const htmlString = content.cloneNode(true);

    const votesCount = (htmlString as HTMLElement).querySelector('.votes_count')?.innerHTML;

    (htmlString as HTMLElement).querySelectorAll('.comment-add')?.forEach( x => x.remove() );

    (htmlString as HTMLElement).querySelectorAll('.comment-avatar')?.forEach( x => x.remove() );

    (htmlString as HTMLElement).querySelectorAll('.btn-download-docx')?.forEach( x => x.remove() );

    (htmlString as HTMLElement).querySelectorAll('.comment-label')?.forEach( comment => comment.setAttribute("style", "") );

    (htmlString as HTMLElement).querySelectorAll('.block_vote_btns')?.forEach( x => x.remove() );

    asBlob(`${(htmlString as HTMLElement).innerHTML} <h2>${intl.formatMessage({ id: "DOC.VOTES" })}: ${votesCount}</h2>`).then((data: any) => {
      saveAs(data, `CODE - ${title}.docx`) // save as docx file
    });
  };

  return (
    <Button
      className="btn-download-docx"
      style={{marginTop: 15}}
      variant="contained"
      color="secondary"
      onClick={ downloadDocx }
    >
      <FormattedMessage id="DOWNLOAD" /> .docx
    </Button>
  );
};

export default injectIntl(BillExportToDocx);
